import styles from './product-filter-buttons.module.scss';
import { useTranslation } from 'next-i18next';

export const ProductFilterButtons = ({ onToggleFilters, onTogglePriceModal }) => {
  const { t } = useTranslation(['common', 'products']);
  return (
    <div className={styles.wrapper}>
      <button
        onClick={onToggleFilters}
        className={`rrs__button ${styles.button} ${styles.filtersOpenButton}`}
      >
        {t('Фильтры')}
        <svg
          width="9"
          height="13"
          viewBox="0 0 9 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.02842 7.9998L7.32092 7.29731L4.53586 10.0972L4.49997 0.0123059L3.49998 0.0158646L3.53587 10.1008L0.735939 7.31575L0.0284701 8.02827L4.04268 12.014L8.02842 7.9998Z"
            fill="#BCA169"
          />
        </svg>
      </button>
      <button onClick={onTogglePriceModal} className={`rrs__button  ${styles.button}`}>
        {t('Запросить прайс')}
      </button>
    </div>
  );
};
